<div class="dialog-container">
  <div class="dialog-header">
    <h1 class="header">Matrix-IDs von {{ data.serviceName }}</h1>
    <h2 class="sub-header">Wählen Sie eine Matrix-ID aus, um diese einzuladen.</h2>
  </div>

  <div class="dialog-filter">
    <app-searchbar [placeholder]="'Schnellsuche'" (searchTermChange)="applyFilter($event)"> </app-searchbar>
  </div>

  <div class="dialog-body">
    <app-generic-table
      [dataSource]="filteredRows"
      [columnsToDisplay]="displayedColumns"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [totalItems]="totalItems"
      (pageChange)="onPageChange($event)">
    </app-generic-table>
  </div>

  <div class="dialog-footer">
    <app-button text="Schließen" (clicked)="close()" [dataTestId]="'matrix_id_close_button'"> </app-button>
  </div>

  <ng-template #actionTemplate let-row>
    @if (this.data.roomInfo.room) {
      <app-button
        text="Einladen"
        [isDisabled]="row.isMember"
        [tooltip]="row.isMember ? 'Bereits eingeladen' : ''"
        (clicked)="invite(row.endpoint)">
      </app-button>
    } @else {
      <app-button text="Erstellen" (clicked)="createRoom(row.endpoint)"> </app-button>
    }
  </ng-template>
</div>
